"use strict";
exports.__esModule = true;
exports.setFormErrorsFromSubmit = exports.setFormErrors = void 0;
/**
 * Created by Marvin on 17.03.17.
 */
var actionTypes_1 = require("./actionTypes");
var setFormErrors = function (name, formErrors) { return ({
    type: actionTypes_1.FORM_ERROR_SET,
    name: name,
    formErrors: formErrors
}); };
exports.setFormErrors = setFormErrors;
var setFormErrorsFromSubmit = function (name, errors) {
    var fatal = {};
    errors.map(function (error) {
        if (!fatal.hasOwnProperty(error.field)) {
            fatal[error.field] = [];
        }
        fatal[error.field].push(error.message);
    });
    return {
        type: actionTypes_1.FORM_ERROR_SET,
        name: name,
        formErrors: { fatal: fatal }
    };
};
exports.setFormErrorsFromSubmit = setFormErrorsFromSubmit;
